export default __webpack_public_path__ + "static/media/dashboard.008e6e69.png";